import React from 'react';
import { heatStyle } from '../usageHeat';

const STEPS = [1, 2, 3, 4, 5];

/** "Menos ▢▢▢▢▢ Más" legend for the usage heat scale (darker = more activity). */
export default function UsageLegend({ noun = 'visitas' }) {
    return (
        <span className="inline-flex items-center gap-1.5 text-xs text-surface-500" title={`Color más oscuro = más ${noun}`}>
            Menos
            {STEPS.map((v) => (
                <span key={v} className="h-3 w-3 rounded-sm border border-surface-200" style={{ background: heatStyle(v, STEPS.length).bg }} />
            ))}
            Más
        </span>
    );
}
